<template>
  <div>
    <b-steps
      v-model="activeStep"
      :animated="true"
      :has-navigation="false"
      size="is-medium"
      @input="onInput"
      class="process-steps"
    >
      <b-step-item
        :label="$t('title.processSelect')"
        icon="project-diagram"
        :clickable="true"
        :type="{ 'is-danger': true }"
      >
        <ProcessSelect @selectProcess="selectProcess"></ProcessSelect>
      </b-step-item>
      <b-step-item
        :label="$t('title.makePreliminary')"
        :clickable="activeStep > 1"
        icon="search"
        :type="{ 'is-danger': true }"
      >
        <ProcessPreliminary
          v-if="process"
          :process="process"
          @next="processNext(2)"
        ></ProcessPreliminary>
      </b-step-item>
      <b-step-item
        :label="$t('title.answer')"
        :clickable="activeStep > 0 && activeStep < 3"
        icon="question"
        :type="{ 'is-danger': true }"
      >
        <ProcessQuestion
          v-if="process && activeStep == 2 && !process.isProcessGroup"
          :process="process"
          @next="processNext(3)"
          @skip="processNext"
          @setScore="setScore"
        ></ProcessQuestion>
        <ProcessQuestionWithPoint
          v-if="process && activeStep == 2 && process.isProcessGroup"
          :process="process"
          @next="processNext(3)"
          @skip="processNext"
          @setScore="setScore"
        ></ProcessQuestionWithPoint>
      </b-step-item>

      <b-step-item
        :label="$t('title.score')"
        :clickable="activeStep > 3"
        icon="chart-pie"
        :type="{ 'is-danger': true }"
      >
        <ProcessScore
          v-if="activeStep == 3"
          @next="processNext(4)"
          :score="score"
          :isProcessGroup="!process || process.isProcessGroup"
        ></ProcessScore>
      </b-step-item>
      <b-step-item
        v-if="!process || !process.isProcessGroup"
        :label="$t('title.report')"
        :clickable="activeStep > 2"
        icon="poll"
        :type="{ 'is-danger': true }"
      >
        <ProcessScore
          v-if="activeStep == 4"
          :score="score"
          @skip="goToStep"
          :textReportActive="true"
        ></ProcessScore>
      </b-step-item>
    </b-steps>
    <router-view></router-view>
  </div>
</template>

<script>
import ProcessSelect from './ProcessSelect.vue'
import ProcessPreliminary from './ProcessPreliminary.vue'
import ProcessQuestion from './ProcessQuestion.vue'
import ProcessQuestionWithPoint from './ProcessQuestionWithPoint.vue'
import ProcessScore from './ProcessScore.vue'

export default {
  components: {
    ProcessSelect,
    ProcessPreliminary,
    ProcessQuestion,
    ProcessQuestionWithPoint,
    ProcessScore
  },
  data () {
    return {
      activeStep: 0,
      previousStep: null,
      process: null,
      score: null,
      report: null
    }
  },
  methods: {
    selectProcess (process) {
      this.process = process
      this.activeStep = 1
    },
    setScore (score) {
      this.score = score
    },
    processNext (stepNo) {
      this.previousStep = this.activeStep
      this.activeStep = stepNo
    },
    goToStep (stepNo) {
      this.previousStep = stepNo - 1
      this.activeStep = stepNo
    },
    onInput (stepNo) {
      if (this.previousStep === 1 && stepNo === 0) {
        this.$buefy.dialog.alert(this.$t('description.quitWhenAnsweringAlert'))
      }
    }
  }
}
</script>
<style>
.process-steps .step-items {
  /* background: #5cc1b3; */
  background: #83d7e7;
  padding: 50px;
}
</style>
